import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';

@Injectable({
  providedIn: 'root',
})
export class DeviceListService {
  private readonly FILTER_COOKIE_NAME = 'device-list-filter';

  constructor(private cookieService: CookieService) {}

  public get filterPreferences(): {
    [key: string]: boolean;
  } {
    try {
      const decoded = atob(
        this.cookieService.get(this.FILTER_COOKIE_NAME) ?? ''
      );
      return JSON.parse(decoded ?? '[]');
    } catch (e) {
      return {};
    }
  }

  public set filterPreferences(value: { [key: string]: boolean }) {
    const encoded = btoa(JSON.stringify(value));
    this.cookieService.put(this.FILTER_COOKIE_NAME, encoded, {
      sameSite: 'strict',
      secure: true,
    });
  }
}
